import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BrokenWatchIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10516_34751)">
            <path
               d="M7.84896 0C6.45833 0 5.33333 1.0125 5.33333 2.26406V3.075C3.43229 3.42188 2 4.93594 2 6.75V17.25C2 19.0641 3.43229 20.5781 5.33333 20.925V21.75C5.33333 22.9922 6.45312 24 7.83333 24H16.1667C17.5469 24 18.6667 22.9922 18.6667 21.75V20.925C20.5677 20.5781 22 19.0641 22 17.25V6.75C22 4.93594 20.5677 3.42188 18.6667 3.075V2.26406C18.6667 1.0125 17.5417 0 16.151 0H7.84896ZM17.8333 5.25C18.7552 5.25 19.5 5.92031 19.5 6.75V17.25C19.5 18.0797 18.7552 18.75 17.8333 18.75H6.16667C5.24479 18.75 4.5 18.0797 4.5 17.25V6.75C4.5 5.92031 5.24479 5.25 6.16667 5.25H17.8333Z"
               fill="currentColor"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M9.16313 13.1844L4.14916 8.45691L2.66051 9.86049L9.16313 15.9915L14.9214 10.5623L19.9354 15.2897L21.424 13.8862L14.9214 7.75512L9.16313 13.1844Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10516_34751">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default BrokenWatchIcon
